module.exports = __webpack_public_path__ + "img/dollar-sign.942040c9.svg";